/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_SharedInputs */



/**
* | output |
* | --- |
* | "The project's files, linked spaces and instructions stay shared with all members." |
*
* @param {Project_Private_Chats_Enable_Confirm_SharedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_shared = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_SharedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_SharedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Dateien, verknüpften Spaces und Anweisungen des Projekts bleiben für alle Mitglieder sichtbar.")
	return /** @type {LocalizedString} */ ("The project's files, linked spaces and instructions stay shared with all members.")
});